export const responsiveActionType = {
    TOGGLE_NAV: 'TOGGLE_NAV'
}

export const ToggleNavigation = (payload?: any) => ({
    type: responsiveActionType.TOGGLE_NAV,
    payload
})